import * as serviceContext from './serviceContext';
import { REPORTS_ROOT as ReportsURL } from '../configs/api';

var options = {};
var headers = new Headers();

headers.append('Content-Type', 'application/json');
options.headers = headers;


export async function tvTempToken(data) {
    
    try {
        const response = await serviceContext.post(ReportsURL + "tv/auth", JSON.stringify(data), options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};